export const AUTH_TOKEN = 'chefpolisAdmTknx';
export const AUTH_USER_KEY = 'chefpolixAdmTknxUser';



// WEBPACK FOOTER //
// ./src/util/constants.js